function isEmpty(value) {
  return value === "" || value === null || value === undefined;
}

function validateCoordinate(value, fieldName) {
  if (isEmpty(value) || typeof value !== "number" || Number.isNaN(value)) {
    return `${fieldName} es obligatoria.`;
  }

  return null;
}

export function validateTarifaZonePayload({
  origin,
  originLat,
  originLng,
  destination,
  destinationLat,
  destinationLng,
  price,
}) {
  if (!origin || !origin.trim()) {
    return "El origen es obligatorio.";
  }

  const originLatError = validateCoordinate(originLat, "La latitud de origen");
  if (originLatError) {
    return originLatError;
  }

  const originLngError = validateCoordinate(originLng, "La longitud de origen");
  if (originLngError) {
    return originLngError;
  }

  if (!destination || !destination.trim()) {
    return "El destino es obligatorio.";
  }

  const destinationLatError = validateCoordinate(
    destinationLat,
    "La latitud de destino",
  );
  if (destinationLatError) {
    return destinationLatError;
  }

  const destinationLngError = validateCoordinate(
    destinationLng,
    "La longitud de destino",
  );
  if (destinationLngError) {
    return destinationLngError;
  }

  if (isEmpty(price)) {
    return "El precio es obligatorio.";
  }

  if (Number.isNaN(Number(price))) {
    return "El precio debe ser un numero decimal valido.";
  }

  if (Number(price) < 0) {
    return "El precio no puede ser negativo.";
  }

  return null;
}
